import { useSelector } from "react-redux";
import { selectAddNewState } from "../../store/slices/dataTablesSlice";
import { TableItem } from "./TableItem";

export function TableBody({ columns, currentTableData, functions }) {
  const isInAddNewState = useSelector(selectAddNewState);
  return (
    <tbody>
      {isInAddNewState && functions.getNew && (
        <TableItem
          columns={columns}
          itemdata={functions?.getNew()}
          isnew={true}
          functions={functions}
        />
      )}
      {!isInAddNewState &&
        currentTableData?.map((tableitem, index) => {
          return (
            <TableItem
              columns={columns}
              key={tableitem?._id ?? index}
              itemdata={tableitem}
              functions={functions}
            />
          );
        })}
    </tbody>
  );
}
